import * as React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Footer from "../components/footer.js"
import Header from "../components/header.js"

import Favicon from "../images/bordr-favicon.png"

const bankCheckoutPage =  () => {
    return (
        <main>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="shortcut icon" type="image/png" href={Favicon}/>
                <meta name="author" content="Bordr Team"></meta>
                <meta name="description" content="Open a Portuguese bank account from anywhere"></meta>
                {/* Open graph data */}
                <meta property="og:title" content="Bordr - Portugal Bank Account Setup Checkout"/>
                <meta property="og:description" content="Open a Portuguese bank account from anywhere in the world" />
                <title>Bordr - Portugal Bank Account Setup Checkout</title>        
                {/* paperform */}
                <script type="text/javascript" async defer>{'(function() {var script = document.createElement("script"); script.src = "https://paperform.co/__embed"; document.body.appendChild(script); })()'}</script>
                {/* iubenda popups */}
                <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
                {/* helpscout beacon */}
                <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
                <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
            </Helmet>
            <section className="bg-yellow-500">
                <div className="max-w-screen-xl mx-auto px-6 py-3">
                <p className="text-white text-center text-lg emoji-icon"><span role="img" aria-label="stopwatch">⏱️</span>&nbsp;&nbsp;Our current bank turnaround time is 3-4 weeks&nbsp;&nbsp;<span role="img" aria-label="stopwatch">⏱️</span></p>
                </div>  
            </section>
            <section className="bg-gray-50 pb-12">
                <Header />
                {/* <div className="max-w-screen-xl mx-auto px-6 w-full md:w-2/3">
                    <div className="pt-16 mb-8 md:mb-10 text-center bg-gray-50">
                        <h1 className="text-4xl md:text-5xl font-bold">Remote Bank Account Setup</h1>
                        <h2 className="text-2xl md:text-3xl font-bold mt-10">We'll be back mid-September</h2>
                        <p className="text-base mt-4">Thank you for your interest in our remote bank setup service. Due to summer vacations in Portugal, our bank branches have limited capacity to support new accounts so we have decided to temporarily stop accepting new orders. Please sign up for our waitlist to get notified when we're up and running again. <span role="img" aria-label="smiley-face">😊</span></p>
                        <div className="mt-8 mb-12"> 
                            <Link to="https://airtable.com/shrViIMdwE9vFaMQm" target="_blank" className="btn-blue">Join the waitlist</Link>
                        </div>                        
                    </div>
                </div> */}
                <div className="pt-16" data-paperform-id="9egcicaf"></div>
            </section>
            <Footer />
        </main>         
    )    
}
export default bankCheckoutPage